<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-append-field>
                    <wbo-text-edit-control formControlName="name" [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    <wbo-entity-discontinued-edit-control formControlName="discontinued"
                                                          [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                </fui-append-field>
            </fui-column>
            <fui-column>
                <wbo-text-edit-control formControlName="thirdPartyId"
                                       [(ngModel)]="model.data.thirdPartyId"></wbo-text-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="requiresPO"
                                           [(ngModel)]="model.data.requiresPO"></wbo-checkbox-edit-control>
            </fui-column>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="chargeAssociatedAccountOnly"
                                           [(ngModel)]="model.data.chargeAssociatedAccountOnly"></wbo-checkbox-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
